module.exports = __webpack_public_path__ + "static/media/IMG_3012.5252aaab.jpg";